//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// suggestion-action-personal-cal imports
import { IRendererProps } from "./SuggestionActionPersonalCal.d";
// other internals
import { CardButton } from "@components/card";
import { SuggestionActionPersonalCal } from "./SuggestionActionPersonalCal";
import { getCurrentOrg } from "@util/org.util";
// relay
import { queries } from "./SuggestionActionPersonalCalRenderer.gql";
// material-ui
import { EventAvailable } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
export class SuggestionActionPersonalCalRenderer extends React.PureComponent<IRendererProps> {
  public render() {
    return (
      <QueryRenderer
        environment={this.props.environment as any}
        query={queries}
        variables={{}}
        render={(readyState: ReadyState) => {
          const viewer = readyState.props && readyState.props.viewer;
          const user = !!viewer && viewer.user;
          const org = !!viewer && getCurrentOrg(viewer);

          if (!user || !org) {
            return (
              <CardButton
                flat
                textColor="white"
                icon={<EventAvailable />}
                label="Sync calendar"
                disabled
              />
            );
          }

          return (
            <SuggestionActionPersonalCal
              actionCallback={this.props.actionCallback}
              user={user}
              org={org}
            />
          );
        }}
      />
    );
  }
}
